<template>
  <div>
    <div class="modal fade" :ref="modalIdandRef" :id="modalIdandRef" tabindex="-1" role="dialog" aria-labelledby="BaseModalLabel" data-backdrop="static" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" style="width:800px;">
          <div class="modal-header">
            <div class="modal-title" id="BaseModalLabel">{{config.modalName}}</div>
            <button type="button" id="btnClose" @click="resetFields" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <slot></slot>
            </div>
          </div>

          <div class="modal-footer">
            <button v-show="isFooter" type="button" id="btnCancel" class="btn btn-secondary" data-dismiss="modal" @click="resetFields">Cancel</button>
            <button v-show="isFooter" type="button" id="btnSave" class="btn btn-primary" @click="saveChanges">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const defaultSettings = {
    modalIdandRef: "BaseModal",
    modalName: "",
    modalAddorEdit: "",
    isFooter: true,
};

export default {
    name: "BaseModal",
    props: {
        config: {
            type: Object,
            default: defaultSettings
        }
    },
    data: function () {
        return this.getModalConfig()
    },
    methods: {
        getModalConfig: function () {
            let self = this,
                data = {};

            Object.keys(defaultSettings).forEach((key) => {

                data[key] = (typeof self.config === "object" &&
                        typeof self.config[key] !== "undefined") ?
                    self.config[key] :
                    defaultSettings[key];
            });

            return data;
        },

        resetFields: function (e) {
            this.$emit("ResetFields", e);
        },
        saveChanges: function (e) {
            this.$emit("SaveChanges", e);
        }
    }
};
</script>
<style>
.modal-header {
	height: 48px;
	color: #4A4A4A;
	background: #D8D8D8;
}
.modal-title {
	font-size: 16px;
	font-weight: bold;
	padding-left: 16px;
}
.modal-body {
	padding-top: 24px !important;
	padding-bottom: 24px !important;
	padding-left: 16px !important;
	padding-right: 16px !important;
}
</style>